<template>
  <img :src="require('./logo.svg')" alt="Bravado" class="bravado-logo" width="122" height="21" />
</template>

<script>
export default {
  name: 'BravadoLogo',
};
</script>

<style scoped lang="scss">
.bravado-logo {
  filter: var(--theme-image-invert);
}
</style>
